const subscriptions = {}

export const REQUEST_FORBIDDEN = 'eventBus/request/forbidden'

export type EventId = typeof REQUEST_FORBIDDEN

export const subscribeToEvent = (eventId: EventId, callback) => {
  if (!subscriptions[eventId]) {
    subscriptions[eventId] = new Set()
  }

  subscriptions[eventId].add(callback)

  // unsubscribe
  return () => {
    subscriptions[eventId].delete(callback)
  }
}

export const emitEvent = (eventId: EventId, ...args) => {
  if (subscriptions[eventId]) {
    subscriptions[eventId].forEach((callback) => callback(...args))
  }
}
